import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import AgriProductAgriApplication from '@/models/AgriProductAgriApplication.js'

export const useAgriProductAgriApplicationStore = defineStore('agriProductAgriApplicationStore', () => {
  let syncableModel = useSyncableModel(useApiResource('agri_product_agri_applications'), {
    className: AgriProductAgriApplication.modelName.name,
    paramKey: AgriProductAgriApplication.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }
}, {
  persist: true
})
